<div class="header-container">
  <app-header text="{{ 'LINK_BEHAVIOUR_CODE' | translate }}"></app-header>
</div>

<main class="content-container">
  <div class="grid-fixed">
    <div class="row">
      <div class="col" size="12" size-md="8" offset-md="2">
        <div class="content">
          <app-static-text [key]="BEHAVIOUR_CODE_KEY"></app-static-text>
        </div>
      </div>
    </div>
  </div>
</main>
